<template>
  <div id="main">
    <div class="top">
      <div class="top1">
        <img
          src="https://source.qunarzz.com/site/images/wns/20220915-shijianchen-est-1.jpeg"
          alt=""
        />
      </div>
      <div class="top2">
        <img
        src="https://source.qunarzz.com/site/images/wns/20220915-shijianchen-est-2.jpeg"
        alt=""
      />
      </div>
    </div>
    <div class="bg2">
      <img
        src="https://source.qunarzz.com/site/images/wns/20220824-shijianchen-2.jpg"
        alt=""
      />
    </div>
    <div class="bg3">
      <img
        src="https://source.qunarzz.com/site/images/wns/20220824-shijianchen-3.jpg"
        alt=""
      />
    </div>
    <div class="bg4">
      <img
        src="https://source.qunarzz.com/site/images/wns/20220824-shijianchen-4.jpg"
        alt=""
      />
    </div>
    <a
      v-maidian="'link1'"
      href="https://mini.hndutyfree.com.cn/#/pages/publicPages/goodDetails/index?goodsId=01C101268&pid=EL2209"
      class="link1 link"
    ></a>
    <a
      v-maidian="'link2'"
      href="https://mini.hndutyfree.com.cn/#/pages/publicPages/goodDetails/index?goodsId=01C055372&pid=EL2209"
      class="link2 link"
    ></a>
    <a
      v-maidian="'link3'"
      href="https://mini.hndutyfree.com.cn/#/pages/publicPages/goodDetails/index?goodsId=01C051263&pid=EL2209"
      class="link3 link"
    ></a>
    <a
      v-maidian="'link4'"
      href="https://mini.hndutyfree.com.cn/#/pages/publicPages/goodDetails/index?goodsId=01C102667&pid=EL2209"
      class="link4 link"
    ></a>
    <a
      v-maidian="'link5'"
      href="https://mini.hndutyfree.com.cn/#/pages/publicPages/goodDetails/index?goodsId=01C102716&pid=EL2209"
      class="link5 link"
    ></a>
    <a
      v-maidian="'link6'"
      href="https://mini.hndutyfree.com.cn/#/pages/publicPages/goodDetails/index?goodsId=01C101262&pid=EL2209"
      class="link6 linkrt"
    ></a>
    <a
      v-maidian="'link7'"
      href="https://mini.hndutyfree.com.cn/#/pages/publicPages/goodDetails/index?goodsId=01C101252&pid=EL2209"
      class="link7 linklf"
    ></a>
    <a
      v-maidian="'link8'"
      href="https://mini.hndutyfree.com.cn/#/pages/publicPages/goodDetails/index?goodsId=01C051263&pid=EL2209"
      class="link8 linkrt"
    ></a>
    <a
      v-maidian="'link9'"
      href="https://mini.hndutyfree.com.cn/#/pages/publicPages/goodDetails/index?goodsId=01C102719&pid=EL2209"
      class="link9 linklf"
    ></a>
    <a
      v-maidian="'link10'"
      href="https://mini.hndutyfree.com.cn/#/pages/publicPages/goodDetails/index?goodsId=01C100963&pid=EL2209"
      class="link10 linkrt"
    ></a>
  </div>
</template>
<script>
import videoComp from './components/videoComp.vue';
import giftDialog from './components/dialog/gift/index';
import loginDialog from './components/dialog/login/index';
import ruleDialog from './components/dialog/rule/index';
export default {
  components: {
    videoComp,
  },
  data() {
    return {
      current: 0,
      imgList: [
        {
          img: 'https://source.qunarzz.com/site/images/wns/20220803-shijianchen-lun1.png',
          type: 'DanxiaBrown',
          title: '欧莱雅山河色丹霞褐棕',
          dialog:
            'https://source.qunarzz.com/site/images/wns/20220803-shijianchen-card-3.png',
          data: {
            span: '【&nbsp;欧莱雅丹霞褐棕&nbsp;一览奇险灵秀&nbsp;】',
            title: '青甘大环线西宁青海湖茶卡盐湖翡翠湖敦煌莫高窟+鸣沙山＋张掖',
            desc: '• 雅丹魔鬼城1U型公路1鸣沙山1七彩丹霞<br/>• 慢节奏无人机航拍 区间车1日月山游玩',
            link: 'https://touch.dujia.qunar.com/p/item/2385610685',
            price: '2920',
          },
        },
        {
          img: 'https://source.qunarzz.com/site/images/wns/20220803-shijianchen-lun2.png',
          type: 'DanxiaTea',
          title: '欧莱雅山河色雅丹茶棕',
          data: {
            span: '【&nbsp;欧莱雅雅丹茶棕&nbsp;乐游陡壁小丘&nbsp;】',
            title: '北疆喀纳斯拼车9日游•穿独库大环线喀纳斯禾木景区沙漠公路',
            desc: '• 单人出行不尴尬，保证拼住不收单房差<br/>• 攀登鱼台俯瞰喀纳斯，赛里木湖环湖旅行',
            price: '5932',
            link: 'https://touch.dujia.qunar.com/p/item/2911884044',
          },
          dialog:
            'https://source.qunarzz.com/site/images/wns/20220803-shijianchen-card-2.png',
        },
        {
          img: 'https://source.qunarzz.com/site/images/wns/20220803-shijianchen-lun3.png',
          type: 'KARST',
          title: '欧莱雅山河色喀斯特黑褐',
          data: {
            span: '【欧莱雅喀斯特黑褐&nbsp;探索岩溶地貌】',
            title: '一江两游漓江竹筏+游船 •桂林漓江阳朔2日遇龙河海陆空',
            desc: '•4A冠岩景区+象鼻山+遇龙河＋十里画廊<br/>• 漓江新玩法：杨堤竹筏＋漓江游船＋观光车',
            link: 'https://touch.dujia.qunar.com/p/item/1863880610',
            price: '369',
          },
          dialog:
            'https://source.qunarzz.com/site/images/wns/20220803-shijianchen-card-1.png',
        },
      ],
    };
  },
  mounted() {
    // this.queryVoteRecord();
    // let index = 2;
    // giftDialog({
    //   img: this.imgList[index].dialog,
    //   title: this.imgList[index].title,
    //   data: this.imgList[index].data,
    // });
  },
  methods: {
    changeIndex(e) {
      this.current = e;
    },
    showRule() {
      ruleDialog({});
    },
    vote() {
      giftDialog({});
      // let index = this.current;
      // this.queryVoteRecord(this.imgList[index].type, (hasVote, showDialog) => {
      //   if (hasVote && showDialog) {
      //     giftDialog({
      //       img: this.imgList[index].dialog,
      //       title: this.imgList[index].title,
      //       data: this.imgList[index].data,
      //     });
      //     return;
      //   } else if (hasVote && !showDialog) {
      //     this.$dialog.alert({
      //       message: '您已选择其他山河风光',
      //     });
      //     return;
      //   }
      //   this.$axios
      //     .post(
      //       '/commonly/voteSpecial?categoryCode=' + this.imgList[index].type,
      //     )
      //     .then((res) => {
      //       if (res.code == 400) {
      //         loginDialog({
      //           callback: () => {
      //             this.vote();
      //           },
      //         });
      //       } else if (res.code != 200) {
      //         this.$dialog.alert({
      //           message: res.message,
      //         });
      //       } else {
      //         giftDialog({
      //           img: this.imgList[index].dialog,
      //           title: this.imgList[index].title,
      //           data: this.imgList[index].data,
      //         });
      //       }
      //     });
      // });
    },
    queryVoteRecord(type, callback) {
      this.$axios.get('/commonly/voteRecord').then((res) => {
        if (res.code == 400) {
          loginDialog({
            callback: () => {
              this.queryVoteRecord(type, callback);
            },
          });
        } else if (res.code != 200) {
          this.$dialog.alert({
            message: res.message,
          });
        } else {
          if (res.data.length == 0) {
            callback && callback(false);
          } else {
            let bool = false;
            res.data.forEach((item) => {
              if (item.voteCategoryCode == type) {
                bool = true;
              }
            });
            callback && callback(true, bool);
          }
        }
      });
    },
  },
};
</script>
<style lang='less' scoped='true'>
.mtSwipe {
  height: 260px;
  /deep/ .mint-swipe-indicators {
    display: none;
  }
}
.top1{
  height:699px;
}
.top2{
  height: 470px;
}
.lookMore {
  position: absolute;
  bottom: 0;
  width: 150px;
  margin-left: auto;
  margin-right: auto;
  left: 50%;
  margin-left: -75px;
}
.top {
  height: 1168px;
}
.submit {
  display: block;
  margin: 0 auto;
  width: 150px;
  margin-top: 20px;
}
.top {
  position: relative;
}
.bg2 {
  height: 2367px;
}
.bg3 {
  height: 2009px;
}
.bg4 {
  height: 1440px;
  overflow-y: hidden;
}
.rule {
  position: absolute;
  bottom: 10px;
  right: 0;
  height: 25px;
}
.bottom {
  position: relative;
  .buy {
    width: 149px;
    height: 30px;
    background: #000000;
    display: flex;
    color: #fff;
    align-items: center;
    justify-content: center;
    margin: 0 auto;
    position: absolute;
    bottom: 39px;
    left: 50%;
    margin-left: -75px;
    text-decoration: none;
  }
}
.link {
  // border:1px solid #f00;
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  top: 0;
  width: 90px;
  height: 21px;
  display: block;
}
.link1 {
  top: 4057px;
}
.link2 {
  top: 4470px;
}
.link3 {
  top: 4829px;
}
.link4 {
  top: 5076px;
}
.link5 {
  top: 5457px;
}
.linkrt {
  // border:1px solid #f00;
  position: absolute;
  right: 66px;
  width: 90px;
  height: 21px;
  display: block;
}
.linklf {
  // border:1px solid #f00;
  position: absolute;
  left: 69px;
  top: 5957px;
  width: 90px;
  height: 21px;
  display: block;
}
.link6 {
  top: 5751px;
}
.link7 {
  top: 5957px;
}
.link8 {
  top: 6164px;
}
.link9 {
  top: 6371px;
}
.link10 {
  top: 6579px;
}
</style>